// extracted by mini-css-extract-plugin
module.exports = {"chatPage":"Chat_chatPage__1VNyN","mobile":"Chat_mobile__2pTXO","form-control":"Chat_form-control__fnGFK"};